__turbopack_context__.v({
  "continueButton": "EtYwlG_continueButton",
  "infoContainer": "EtYwlG_infoContainer",
  "infoText": "EtYwlG_infoText",
  "row": "EtYwlG_row",
  "selected": "EtYwlG_selected",
  "selectedTimeSlot": "EtYwlG_selectedTimeSlot",
  "skeleton": "EtYwlG_skeleton",
  "timeSlotContainer": "EtYwlG_timeSlotContainer",
});
